import React from 'react';
import PropTypes from 'prop-types';

const DefaultImage = ({ src, defaultImage, alt }) => {
  const renderDefaultImage = (e) => {
    e.target.src = defaultImage;
  };

  return <img src={src || defaultImage} onError={renderDefaultImage} alt={alt} />;
};

DefaultImage.propTypes = {
  src: PropTypes.string,
  defaultImage: PropTypes.string.isRequired,
  alt: PropTypes.string,
};

DefaultImage.defaultProps = {
  src: null,
  alt: null,
};

export default DefaultImage;
